// DO NOT EDIT, GENERATED BY "yarn sheets"

import type { WristLiningRow } from '../typings';

const data = [
  {
    "id": "boa",
    "name": "BOA",
    "description": "A soft, lightweight synthetic material designed to be soft to the touch.",
    "subsets": {
      "leatherId": {
        "pcfp": true
      }
    }
  }
] as const;

type Primitive = string | number | boolean | null | undefined;
type Immutable<T> = T extends Primitive
  ? T
  : { readonly [K in keyof T]: Immutable<T[K]> };

type Combine<T extends U, U> = T extends Readonly<Primitive | Primitive[]>
  ? T
  : T extends ReadonlyArray<infer I>
  ? Readonly<Combine<I, Extract<U, Readonly<any[]>>[number]>[]>
  : U extends Readonly<Primitive | any[]>
  ? never
  : string extends keyof U
  ? { [K in keyof T & string]: Combine<T[K], U[K]> }
  : number extends keyof U
  ? { [K in keyof T & number]: Combine<T[K], U[K]> }
  : symbol extends keyof U
  ? { [K in keyof T & symbol]: Combine<T[K], U[K]> }
  : { [K in keyof U]: Combine<T[K], U[K]> };

const typed: Combine<typeof data, Immutable<WristLiningRow[]>> = data;

export type WristLining = typeof typed[number];

export const WRIST_LINING_INDEX_KEY = "id";
export type WristLiningIndexKey = "id";
export type WristLiningId = WristLining["id"];

let i = 0;
export const WRIST_LINING_DICT = {
  "boa": typed[i++]
} as const;

export { typed as WRIST_LININGS };
